module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-modal', {
    attrs: {
      "visible": _vm.tipWarning,
      "title": "提示"
    },
    on: {
      "closemodal": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('div', {
    staticClass: "message"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _c('div', {
    staticClass: "btn-container"
  }, [(_vm.hasRemember) ? _c('label', [_c('v-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    domProps: {
      "value": (_vm.remember)
    },
    on: {
      "input": function($event) {
        _vm.remember = $event
      }
    }
  }), _c('span', {
    staticClass: "remember"
  }, [_vm._v("知道了，不再提醒")])], 1) : (!_vm.isOutTime) ? _c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toWebsite()
      }
    }
  }, [_vm._v("去设置")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("确认")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-771ade86", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-771ade86!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/codetipModal.vue
// module id = 773
// module chunks = 0